// Every game on the site, in the order the Games page lists them.
//   glyph - the character shown as the game's icon (the quick web games); image - a picture used instead
//   path - where the game is played on this site; url - a game hosted at its own address
//   scores - where its leaderboard is; left out for a game that has no leaderboard yet
export const GAMES = [
    {
        name: "Solarflare",
        image: "/img/cards/solarflare-logo.png",
        url: "https://solarflare.clomp.io",
        scores: "/leaderboard?game=solarflare",
        description: "Our first full-scale game: escape, explore and survive across the frontier worlds. Now in alpha."
    },
    {
        name: "Space Jump",
        image: "/img/cards/spacejump/spacejump-logo.png",
        pixelArt: true,
        url: "https://spacejump.clomp.io",
        scores: "/leaderboard?game=spacejump",
        description: "Charge your jump and climb from the launchsite to the stars, one platform at a time."
    },
    {
        name: "Clompy Clicker",
        glyph: "☕",
        path: "/clompyclicker",
        scores: "/leaderboard?game=clompyclicker",
        description: "Click the mug to collect diamonds, and climb the leaderboard."
    },
    {
        name: "Clomple",
        glyph: "C",
        path: "/clomple",
        description: "Guess the secret word in 6 guesses. The first is always CLOMP."
    },
    {
        name: "Nonogram",
        glyph: "▦",
        path: "/nonogram",
        description: "Select the correct squares in each row and column to fill in the grid."
    },
    {
        name: "Mania",
        glyph: "♪",
        path: "/mania",
        description: "Hit keys to follow the music."
    }
];

// The quick games played on this site, in the order the home page lists them
export const WEB_GAMES = ["Clomple", "Nonogram", "Mania", "Clompy Clicker"].map((name) => GAMES.find((game) => game.name === name));
